

































import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
class Overview extends Vue {
  @State(state => state.defi.account.loading) loading;

  @State(state => state.defi.account.wealthes) wealthes;

  get meta() {
    const balance = (this.wealthes && this.wealthes.balance) || 0;
    const totalRevenue = (this.wealthes && this.wealthes.total_revenue) || 0;
    const lastRevenue = (this.wealthes && this.wealthes.last_revenue) || 0;
    const fiat = this.$common.utils.currency.fiat;
    const addSymbol = this.$common.utils.number.addSymbol;
    const getColor = this.$common.utils.helper.getColor;
    const totalBalanceLegal = fiat(this, {
      value: balance,
      from: "USDT"
    });
    const totalRevenueLegal = fiat(this, {
      value: totalRevenue,
      from: "USDT"
    });
    const lastRevenueLegal = fiat(this, {
      value: lastRevenue,
      from: "USDT"
    });
    return {
      balance: `${totalBalanceLegal}`,
      totalRevenue: `${addSymbol(totalRevenueLegal)} ${this.currency.unit}`,
      revenueColor: getColor(this.$store, totalRevenueLegal),
      lastRevenue: addSymbol(lastRevenueLegal),
      lastRevenueColor: getColor(this.$store, this.wealthes.last_revenue)
    };
  }

  get currency() {
    return {
      symbol: this.$common.utils.currency.getCurrentCurrency(this.$store),
      unit: this.$common.utils.currency.getCurrenctCurrencyUnit(this.$store)
    };
  }

  handleToMine() {
    this.$helper.toFusionPath(this, "defi", {
      name: "mine"
    });
  }
}
export default Overview;
